import { FETCH_HISTORY_SUCCESS } from '.'

const fetchHistorySuccessAction = (payload) => {
  return {
    type: FETCH_HISTORY_SUCCESS,
    payload
  }
}

export { fetchHistorySuccessAction }
